import { Dropdown } from 'react-bootstrap';
import { ThreeDotsVertical } from 'react-bootstrap-icons';

interface IOwnProps {
    children?: React.ReactNode;
    index?: number;
}
export const Actions: React.FC<IOwnProps> = (props: IOwnProps) => {
    return (
        <Dropdown>
            <Dropdown.Toggle className="rounded-circle d-flex justify-content-between align-items-center p-2 m-0" variant="secondary" id={`dropdown-${props.index}`}>
                <ThreeDotsVertical />
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {props.children}
            </Dropdown.Menu>
        </Dropdown>
    );
};